var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { translate } from '../../Services/translation';
import { elfack2025, // remove after elfack?
arrows, warnings, electric, industry, construction, plumbing, ventilation, harbour, publicsector, security, recycling, traffic, larm, fire, danger, animal } from './Utils/EditorSvgIcons';
import { CANVAS_OBJECT_ADDED } from '../../Rutab/RutabConstants';
import { addIcon } from '../../Editor/CanvasService';
const categories = {
    elfack2025, // remove after elfack?
    arrows,
    warnings,
    electric,
    industry,
    construction,
    plumbing,
    ventilation,
    harbour,
    publicsector,
    security,
    recycling,
    traffic,
    larm,
    fire,
    danger,
    animal
};
const IconCategory = ({ icons, onIconClick }) => {
    const svgToDataUrl = (svgString) => {
        return `data:image/svg+xml;charset=utf-8,${encodeURIComponent(svgString)}`;
    };
    return (_jsx("div", { className: "icon-category", children: _jsx("div", { className: "icon-grid", children: icons.map((icon) => (_jsx("div", { className: "icon-item", onClick: () => onIconClick(icon.svg), children: _jsx("img", { src: svgToDataUrl(icon.svg), alt: icon.id }) }, icon.id))) }) }));
};
export const ImageSelectorDialogIconLibrary = ({ canvas }) => {
    const [selectedCategory, setSelectedCategory] = useState(Object.keys(categories)[0]);
    const dispatch = useDispatch();
    const handleCategoryChange = (event) => {
        setSelectedCategory(event.target.value);
    };
    const handleIconClick = (svgString) => __awaiter(void 0, void 0, void 0, function* () {
        if (!canvas)
            return;
        yield addIcon(canvas, svgString);
        dispatch({ type: CANVAS_OBJECT_ADDED });
    });
    const isValidCategory = (key) => {
        return key in categories;
    };
    return (_jsxs(_Fragment, { children: [_jsxs("div", { className: "library", children: [_jsx("h3", { children: "Bilbibliotek" }), _jsx("select", { onChange: handleCategoryChange, children: Object.keys(categories).map((icon, index) => (_jsx("option", { value: icon, children: translate(`decal.imageselectordialog.category.${icon}`) }, index))) }), _jsx("p", { className: "info-text", children: "Klicka p\u00E5 den bild du vill ha f\u00F6r att visa den p\u00E5 arbetsytan." })] }), selectedCategory && isValidCategory(selectedCategory) && (_jsx(IconCategory, { icons: categories[selectedCategory], onIconClick: handleIconClick }))] }));
};
